import {AnyAction, combineReducers, createStore, Store} from 'redux';
import {MiranaReducer} from './mirana-reducer';
import {reducer as reduxFormReducer} from 'redux-form';
import MiranaState from './mirana-state';
import {customizerReducer, sidebarReducer, themeReducer} from '../theme/redux/reducers/index';
import {reducer as notifications} from 'react-notification-system-redux';

function myCreateStore(): Store<MiranaState, AnyAction> {
    // Create a store with a chained reducer
    return createStore(combineReducers({
        notifications,
        app: MiranaReducer.reduce,
        form: reduxFormReducer, // mounted under "form",
        theme: themeReducer,
        sidebar: sidebarReducer,
        customizer: customizerReducer
    }));
}

// The main store creator that will hold all the other stores
export default myCreateStore;



// WEBPACK FOOTER //
// ./src/reduxstore/create-store.ts